import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Topbar } from '../components/Topbar';
import { Empty } from '../components/ui/empty';

export default function NotFound(): JSX.Element {
  return (
    <>
      <Topbar title="Not found" />
      <div className="px-6 py-10">
        <Empty
          icon={FileQuestion}
          title="Page not found"
          description="The link you followed doesn't lead anywhere in the admin panel."
          action={
            <Link to="/" className="text-sm text-brand hover:underline">
              Back to dashboard
            </Link>
          }
        />
      </div>
    </>
  );
}
